<div class="container-popup" (click)="stopProp($event)">
  <div class="header">
    <h2>{{ dialogThirdPartyTitle }}</h2>
  </div>
  <form
    class="third-party-form"
    #form="ngForm"
    [formGroup]="thirdPartyForm"
    (ngSubmit)="addEditThirdParty()"
    novalidate
  >
    <div class="modal-form-body">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <app-input-field
              [label]="'Type'"
              [type]="InputFieldType.Dropdown"
              [options]="allThirdPartiesTypes"
              [optionsLoading]="isLoadingType"
              optionLabel="name"
              [form]="thirdPartyForm"
              [controlName]="'type'"
            ></app-input-field>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="thirdPartyForm.value?.type !== 1">
        <div class="col-md-12">
          <div class="form-group">
            <label class="form-label">Company</label>
            <input
              type="text"
              formControlName="name"
              class="form-control"
              placeholder="Company Name"
              maxlength="60"
            />
            <app-form-errors
              [color]="'danger'"
              [form]="form"
              [control]="thirdPartyForm.controls['name']"
            >
            </app-form-errors>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="form-label">Internal Code</label>
            <input
              type="text"
              formControlName="internal_code"
              class="form-control"
              placeholder="Internal Code"
              maxlength="60"
            />
            <app-form-errors
              [color]="'danger'"
              [form]="form"
              [control]="thirdPartyForm.controls['internal_code']"
            >
            </app-form-errors>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div class="form-group">
            <label class="form-label">Title</label>
            <div class="auto-complete">
              <span
                *ngIf="titleAutoComplete.loadScrollingData"
                class="auto-complete-spinner"
              >
                <span class="pi pi-spinner pi-spin"></span>
              </span>
              <p-autoComplete
                formControlName="title"
                (completeMethod)="titleAutoComplete.onQueryChange($event)"
                (onSelect)="titleAutoComplete.onSelected($event)"
                [suggestions]="titleAutoComplete.suggestions"
                placeholder="Title"
                field="name"
                [completeOnFocus]="true"
                (onShow)="titleAutoComplete.paginationScrolling()"
              >
                <!-- [loading]="typeAutoCompete.loading" -->
              </p-autoComplete>
            </div>
            <app-form-errors
              [color]="'danger'"
              [form]="form"
              [control]="thirdPartyForm.controls['title']"
            >
            </app-form-errors>
          </div>
        </div>

        <div class="col-md-4">
          <div class="form-group">
            <label class="form-label"
              >{{
                thirdPartyForm.value?.type === 1
                  ? "Customer First Name"
                  : "Owner First Name"
              }}<span>*</span></label
            >
            <input
              type="text"
              formControlName="first_name"
              class="form-control"
              maxlength="60"
            />
            <app-form-errors
              [color]="'danger'"
              [form]="form"
              [control]="thirdPartyForm.controls['first_name']"
            >
            </app-form-errors>
          </div>
        </div>
        <!-- <div class="col-md-3">
                <div class="form-group m-name">
                  <input
                    type="text"
                    formControlName="middle_name"
                    class="form-control"
                    placeholder="Middle Name"
                  />
                  <app-form-errors
                    [color]="'danger'"
                    [form]="form"
                    [control]="thirdPartyForm.controls['middle_name']"
                  >
                  </app-form-errors>
                </div>
              </div> -->
        <div class="col-md-4">
          <div class="form-group">
            <label class="form-label"
              >{{
                thirdPartyForm.value?.type === 1
                  ? "Customer Last Name"
                  : "Owner Last Name"
              }}<span>*</span></label
            >
            <input
              type="text"
              formControlName="last_name"
              class="form-control"
              maxlength="60"
            />
            <app-form-errors
              [color]="'danger'"
              [form]="form"
              [control]="thirdPartyForm.controls['last_name']"
            >
            </app-form-errors>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label for="" class="form-label">Email</label>
            <input type="email" formControlName="email" class="form-control" />
            <app-form-errors
              [color]="'danger'"
              [form]="form"
              [control]="thirdPartyForm.controls['email']"
            >
            </app-form-errors>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="" class="form-label">Phone<span>*</span></label>
            <input
              type="text"
              formControlName="phone"
              class="form-control"
              mask="(000) 000-0000"
              [validation]="true"
              [dropSpecialCharacters]="false"
            />
            <app-form-errors
              [color]="'danger'"
              [form]="form"
              [control]="thirdPartyForm.controls['phone']"
            >
            </app-form-errors>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label for="" class="form-label">Web URL</label>
        <input
          type="text"
          formControlName="web_url"
          class="form-control"
          placeholder="Web URL"
        />
        <app-form-errors
          [color]="'danger'"
          [form]="form"
          [control]="thirdPartyForm.controls['web_url']"
        >
        </app-form-errors>
      </div>
      <div class="street-address-container">
        <p>(if mailing address is a P.O. Box please provide street address )</p>

        <app-address-component [addressForm]="formAddress">
        </app-address-component>
      </div>

      <app-input-field
        class="checkbox-input"
        [form]="thirdPartyForm"
        [type]="InputFieldType.Checkbox"
        [showLabel]="false"
        controlName="flagged"
        label="Flag User"
      ></app-input-field>

      <ng-container *ngIf="thirdPartyForm?.value?.flagged">
        <app-input-field
          [form]="thirdPartyForm"
          [type]="InputFieldType.TextArea"
          controlName="flag_notes"
          label="Flag Note"
        ></app-input-field>
      </ng-container>

      <app-custom-field-form
        #customFieldComponent
        [form]="thirdPartyForm"
        [module]="'thirdParty'"
        [data]="thirdPartyForm.value?.customFieldsArrValue"
      >
      </app-custom-field-form>

      <div class="footer">
        <button
          type="button"
          class="cancel-btn"
          (click)="closeModalOutside($event)"
        >
          Cancel
        </button>
        <button
          *ngIf="
            isEditThirdPartyDialog &&
            _pService.hasPermission('delete_third_party')
          "
          (click)="deleteMsgComponentThirdParty.open()"
          [disabled]="loadingDelete"
          type="button"
          class="custom-btn delete-btn"
        >
          Delete
          <!-- <i *ngIf="loadingDelete" class="fa-spin fas fa-spinner"></i> -->
        </button>
        <button type="submit" class="custom-btn">
          {{ isEditThirdPartyDialog ? "Update" : "Create" }}
          <i *ngIf="loadingSubmit" class="fa-spin fas fa-spinner"></i>
        </button>
      </div>
    </div>
  </form>
</div>

<app-confirmation-msg
  class="conformation"
  #messageComponent
  [isLoading]="loadingConfirm"
  (accepted)="accepted()"
  (rejected)="rejected()"
  [headerMessage]="'Confirmation Message'"
  [bodyMessage]="'Are you sure you want to discard your data?'"
>
</app-confirmation-msg>

<app-confirmation-msg
  class="conformation"
  #deleteMsgComponent
  [isLoading]="loadingConfirm"
  (accepted)="deleteThirdPartyType()"
  (rejected)="deleteMsgComponent.close()"
  [headerMessage]="'Confirmation Message'"
  [bodyMessage]="'Are you sure you want to delete this third party type?'"
>
</app-confirmation-msg>

<app-confirmation-msg
  class="conformation"
  #deleteMsgComponentThirdParty
  [isLoading]="loadingConfirm"
  (accepted)="deleteThirdParty()"
  (rejected)="deleteMsgComponent.close()"
  [headerMessage]="'Confirmation Message'"
  [bodyMessage]="'Are you sure you want to delete this third party type?'"
>
</app-confirmation-msg>
